module.exports = __webpack_public_path__ + "images/graphic-footer@2x_5464443972945dfa2af9bfff1b476614.png";